import { api } from "@services/api"
import {
  addToCartService,
  getCartItemsService,
  deleteCartItemService,
  getAllCartItemsService,
  updateCartItemService,
} from "./cart-service"

export const addCartApi = api.injectEndpoints({
  endpoints: (build) => ({
    //add to cart
    addToCart: build.mutation({
      queryFn: async (body) => {
        const result: any = await new Promise((resolve) =>
          addToCartService(body)
            .then((data) => resolve(data))
            .catch((error) => {
              if (error) {
                resolve({ data: null, error: error.response.data })
              }
            })
        )
        return { data: result, error: result.error }
      },

      invalidatesTags: ["Cart"],
    }),

    //get cart items
    getCartItems: build.query({
      queryFn: async ({ uid }) => {
        const result: any = await new Promise((resolve) =>
          getCartItemsService(uid)
            .then((data) => resolve(data))
            .catch((error) => {
              if (error) {
                resolve({ data: null, error: error.response.data })
              }
            })
        )

        return { data: result, error: result.error }
      },
      providesTags: ["Cart"],
    }),

    //get cart items for admin
    getAllCartItems: build.query({
      queryFn: async ({ forApprovals }) => {
        const result: any = await new Promise((resolve) =>
          getAllCartItemsService({ forApprovals })
            .then((data) => resolve(data))
            .catch((error) => {
              if (error) {
                resolve({ data: null, error: error.response.data })
              }
            })
        )

        return { data: result, error: result.error }
      },
      providesTags: ["Cart"],
    }),

    //delete cart item
    deleteCartItem: build.mutation({
      queryFn: async (body) => {
        const result: any = await new Promise((resolve) =>
          deleteCartItemService(body)
            .then((data) => resolve(data))
            .catch((error) => {
              if (error) {
                resolve({ data: null, error: error.response.data })
              }
            })
        )

        return { data: result, error: result.error }
      },
      invalidatesTags: ["Cart"],
    }),

    //delete cart item
    updateCartItem: build.mutation({
      queryFn: async (body) => {
        const result: any = await new Promise((resolve) =>
          updateCartItemService(body)
            .then((data) => resolve(data))
            .catch((error) => {
              if (error) {
                resolve({ data: null, error: error.response.data })
              }
            })
        )

        return { data: result, error: result.error }
      },
      invalidatesTags: ["Cart"],
    }),
  }),
})

export const {
  useAddToCartMutation,
  useGetCartItemsQuery,
  useGetAllCartItemsQuery,
  useDeleteCartItemMutation,
  useUpdateCartItemMutation,
} = addCartApi
